import { render } from "./Guardian_Information.vue?vue&type=template&id=6b3ac058&scoped=true"
import script from "./Guardian_Information.vue?vue&type=script&lang=js"
export * from "./Guardian_Information.vue?vue&type=script&lang=js"

import "./Guardian_Information.vue?vue&type=style&index=0&id=6b3ac058&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3ac058"]])

export default __exports__